import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { useTranslations } from "../../contexts/translationContext";
import { StringWithFormat } from "../../types/Result";
import FormHeader, { FormHeaderProps } from "./FormHeader";

export interface FormProps {
    title?: string | StringWithFormat,
    legend?: any,
    actions?: JSX.Element
    children: any | any[]
}

const Form = (props: FormProps) => {
    let subComponentList = Object.keys(Form)
    let subComponents = subComponentList.map((key) => {
        return React.Children.map(props.children, (child) => {
            if (child && child.type)
                return child.type._type === key ? child : null
        });
    });


    //console.log(subComponents)

    return (
        <Container fluid>
            <Row>
                <Col md={12}>
                    <form>
                        <div className="card">
                            {subComponents.map((component) => component)}
                        </div>
                    </form>
                </Col>
            </Row>
        </Container>
    );
}

const Header = (props: FormHeaderProps) => <FormHeader {...props}>{props.children}</FormHeader>;
Header._type = 'Header';
Form.Header = Header;

const Content = (props) => <div className="content">{props.children}</div>;
Content._type = 'Content';
Form.Content = Content;

const Footer = (props) => <div className = "footer">{props.children}</div>;
Footer._type = 'Footer';
Form.Footer = Footer;

const actionButtonsStyle: React.CSSProperties = { float: 'right' }
const Actions = (props) => <div style={actionButtonsStyle}>{props.children}</div>
Actions._type = 'Actions'
Form.Actions = Actions;

export default Form;